import { Component, OnInit, Input, ViewChild, TemplateRef, OnDestroy, SimpleChanges, ElementRef } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Order } from 'src/app/shared/models/order';
import { MetaDataOrders, CasesFacade } from 'src/app/abstraction/cases.facade';
import { OrdersQPS, PatchOrderBody, CasesService } from 'src/app/core/services/cases.service';
import { Case } from 'src/app/shared/models/case';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { OrdersStates } from 'src/app/core/enums/ordersStates';
import { GeneralService } from 'src/app/core/services/general.service';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { CustomValidators } from 'src/app/core/validators/custom-validators';
import { Item } from 'src/app/shared/models/item';
import { EntitiesFacade } from 'src/app/abstraction/entities.facade';
import { Provider } from 'src/app/shared/models/provider';
import Swal from 'sweetalert2';
import mime from 'mime';

import { SelectionModel } from '@angular/cdk/collections';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AttentionsFacade } from '../../../../abstraction/attentions.facade';
import { ProvisionAgreementFilters } from 'src/app/shared/models/ProvisionAgreementFilters';
import { ProvisionsFacade, AUTHORIZATION_COLORS, AUTHORIZATION_BACKGROUND_COLORS } from 'src/app/abstraction/provisions.facade';
import moment from 'moment';
import { ProvisionFee } from 'src/app/shared/models/provisionFee';
import { EvolutionsDialogComponent } from '../evolutions-dialog/evolutions-dialog.component';
import { EvolutionsFacade } from '../../../../abstraction/evolutions.facade';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Attention } from 'src/app/shared/models/attention';
import { MessageDialogComponent } from 'src/app/shared/components/message-dialog/message-dialog.component';
import { Provision } from 'src/app/shared/models/provision';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { ViewManagementEntities } from 'src/app/core/enums/ViewManagementEntities';
import { OrderSharedActionsService } from '../../services/order-shared-actions.service';
import { ExperienceI18nService } from 'src/app/core/experience/experience-i18n.service';
import { AuthorizationState } from 'src/app/core/enums/authorizationState';
import { AttentionStates } from 'src/app/core/enums/attentionsStates';
import { HttpBaseResponseErrorTeaPot } from 'src/app/shared/models/httpBaseResponseErrorTeaPot';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-order-list',
    templateUrl: './order-list.component.html',
    styleUrls: ['./order-list.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed, void', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class OrderListComponent implements OnInit, OnDestroy {

    @Input() case: Case;
    @Input() isCollapsed: boolean = false;
    @Input() allProvisionsWithoutFilter: Provision[];

    @ViewChild('myPond', { static: false }) myPond: any;
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild('modifyOrderTemplate', { static: true }) modifyOrderTemplate: TemplateRef<any>;
    @ViewChild('popUpMessage', { static: true }) popUpMessage: TemplateRef<any>;
    @ViewChild('savingOrderTemplate', { static: true }) savingOrderTemplate: TemplateRef<unknown>;
    @ViewChild('supplyOrdersFocus') matTable: ElementRef;
    private savingOrderDialog: MatDialogRef<unknown> | null = null;

    selection = new SelectionModel<Order>(true, []);
    ORDERS_STATES = OrdersStates;
    orders$: Observable<Order[]>
    _orders: Subscription;
    orders: Order[];
    _mdo: Subscription;
    isLoadingGettingOrders: boolean;
    _isLoadingGettingOrders: Subscription;
    isLoadingUpdatingOrder: boolean;
    _isLoadingUpdatingOrder: Subscription;
    isLoadingCreatingOrder: boolean;
    _isLoadingCreatingOrder: Subscription;
    isLoadingUpdatingOrder$: Observable<boolean>;
    isLoadingUpdatingProvision$: Observable<boolean>;
    isLoadingCreatingProvision$: Observable<boolean>;
    isLoadingGettingAttentions$: Observable<boolean>;
    _provisionsDisplayedOnScreen: Subscription;
    _attentions: Subscription;
    attentions: Attention[];
    provisionFees: ProvisionFee[] = []
    metaDataOrders: MetaDataOrders;
    dataSource;
    dataSourceSupplies;
    _dialogRef;
    _historyModeDate: Subscription;
    _jumpToScreen:Subscription;
    historyFromDate: Date;
    historyToDate: Date;
    actualOrder: Order;
    deliveringOrder: boolean = false;
    editingOrder: boolean = false
    formModifyOrder: FormGroup;
    providersOnSelect: Provider[];
    actualOrderProvider;
    photoInvoice = null;
    fileChanged;
    expandedElement: any;
    loadingAddFile: boolean = false;
    toDay: Date = moment(new Date(), 'YYYY-MM-DD').toDate();
    AUTHORIZATION_COLORS = AUTHORIZATION_COLORS;
    message: string;
    txtConfirmBtn: string;
    txtCancelBtn: string;
    showConfirmBtn: boolean;
    closeAll: boolean = false;
    arrayTable = [];
    _viewManagementEntities= ViewManagementEntities;
    AUTHORIZATION_BACKGROUND_COLORS = AUTHORIZATION_BACKGROUND_COLORS;
    displayedColumnsCollapsed: string[] = [
        'arrow',
        'checkbox',
        'id',
        'provider',
        'quantity'
    ]
    displayedColumns: string[] = [
        'arrow',
        'checkbox',
        'id',
        'provider',
        'quantity',
        'orderDate',
        'deliveryDate',
        'state',
        'updateOrder',
        //'delete'
    ];

    // 'supplyDelivery',
    displayedColumnsSuppliesDeliveringOrder: string[] = [
        'supplyRequested',
        'quantityRequested',
        'priceRequested',
        'quantityDelivery',
        'priceDelivery',
        'marginDelivery',
        'feeDelivery',
        'fixedPriceDelivery'
    ];

    displayedColumnsSupplies: string[] = [
        'supplyRequested',
        'quantityRequested',
        'priceRequested'
    ];
    displayedColumnsPopUp: string[] = ['supplyName', 'quantity', 'provider'];
    public readonly ORDER_ITEMS = 'items';
    public readonly ORDER_PROVIDER = 'providerId';
    public readonly ORDER_PROVIDER_SEARCHING = 'providerSearching'
    public readonly ORDER_DATE = 'orderDate';
    public readonly ORDER_DATE_DELIVERY = 'deliveryDate';
    public readonly ORDER_OBSERVATIONS = 'observations';
    public readonly ORDER_CONFIRMED = 'state';
    public readonly ITEM_QUANTITY = 'quantityOrdered';
    public readonly ITEM_QUANTITY_DELIVERY = 'quantityDelivered';
    public readonly ITEM_PRICE_DELIVERY = 'priceDelivered';
    public readonly ITEM_ID = 'id';
    public readonly ITEM_PRICE = 'priceOrdered';
    public readonly ITEM_PRACTICE_SEARCHING = 'practiceItemSearching';
    public readonly ITEM_PRACTICE_DELIVERY = 'practiceItemDelivered';
    public readonly ITEM_PRACTICE = 'practice';
    public readonly ITEM_UNIT = 'unit';
    public readonly ITEM_KAIROS = 'fixedPrice'; // Kairos
    public readonly ITEM_VISIBLE_CHECK_KAIROS = 'visibleCheckKairos';
    public readonly ITEM_FEE = 'fee'; // provisionFee
    public readonly ITEM_MARGIN = 'profitMargin'; // Margin
    public readonly IS_BILLABLE = 'isBillable'; // Checkbox
    evolutions$: Observable<any>;
    _evolutions: Subscription;

    isBillable: boolean = false;
    deliveryNote: boolean = false

    get confirmed() {
        return this.formModifyOrder.get(this.ORDER_CONFIRMED).value;
    }
    get itemsFormArray(): FormArray {
        return this.formModifyOrder.get(this.ORDER_ITEMS) as FormArray;
    }

    constructor(
        private casesFacade: CasesFacade,
        public generalService: GeneralService,
        public dialog: MatDialog,
        private formBuilder: FormBuilder,
        public entitiesFacade: EntitiesFacade,
        private casesService: CasesService,
        private attentionsFacade: AttentionsFacade,
        private provisionsFacade: ProvisionsFacade,
        private evolutionsFacade: EvolutionsFacade,
        private _bottomSheet: MatBottomSheet,
        private breadcrumbService: BreadcrumbService,
        public orderSharedActionsService: OrderSharedActionsService,
        private experienceI18n: ExperienceI18nService,
    ) {
        this.isLoadingUpdatingOrder$ = this.casesFacade.isLoadingUpdatingOrder$();
        this.isLoadingUpdatingProvision$ = this.provisionsFacade.isLoadingUpdatingProvision$();
        this.isLoadingCreatingProvision$ = this.provisionsFacade.isLoadingCreatingProvision$();
        this.isLoadingGettingAttentions$ = this.attentionsFacade.isLoadingGetAttentions$();
    }

    swalWithCustomizeButtons: any;
    _filtersOnProvisions: Subscription;
    provisionAgreementsInput: ProvisionAgreementFilters;

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource();
        this.dataSourceSupplies = new MatTableDataSource();
        this.calculateNameProvider = this.calculateNameProvider.bind(this);
        this.subscribeToData();

        this.swalWithCustomizeButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btnSwalConfirm',
                cancelButton: 'btnSwalCancel'
            },
            buttonsStyling: true
        })

        this._orders = this.casesFacade.getOrdersDisplayedOnScreen$().subscribe((orders: Order[]) => {
            let ordersFiltered = orders.filter(order => order.items[0]?.caseModuleId == null);
            // const ordersFiltered = orders.filter(order => order.state?.id == this.ORDERS_STATES.CANCELADO || (order.items ?? []).some(item => item?.caseModuleId == null));
            if (!!ordersFiltered) {
                this.orders = ordersFiltered
                ordersFiltered.forEach(order=>{
                    if(order.state.id == 2){
                        order.paintedType = ViewManagementEntities.SUPPLIES_NOT_DELIVERED
                    }else{
                        order.paintedType = null
                    }
                })
                this.dataSource.data = ordersFiltered.sort((a, b) => {
                    let aId = a.id;
                    let bId = b.id;
                    return aId > bId ? - 1 : 1;
                });
                this.setOrderComposeWithProvisionFee();
            }
        })
    }

    ngAfterViewInit(){
        this._jumpToScreen = this.breadcrumbService.getScreenToJump$().subscribe(event => {
            if (event == ViewManagementEntities.SUPPLIES_NOT_DELIVERED) {
                                    this.setFocusOnOrderSupplyTable()
                        }})
    }

    setFocusOnOrderSupplyTable(){
        if(this.matTable){
            try{
                this.matTable.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                this.matTable.nativeElement.focus();
            }catch(err){
                console.log(err);

            }

            }
        }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['allProvisionsWithoutFilter']) {
            this.allProvisionsWithoutFilter = changes['allProvisionsWithoutFilter'].currentValue;
        }
    }

    ngOnDestroy() {
        this.closeSavingOrderDialog();
        this._jumpToScreen.unsubscribe();
        this.breadcrumbService.setScreenToJump(null)
        this._isLoadingCreatingOrder.unsubscribe()
        this._isLoadingGettingOrders.unsubscribe()
        this._isLoadingUpdatingOrder.unsubscribe()
        this._mdo.unsubscribe()
        this._orders.unsubscribe()
        this._filtersOnProvisions.unsubscribe();
        this._historyModeDate.unsubscribe();
    }

    subscribeToData() {
        this.orders = [];
        // this._allProvisionsWithoutFilter = this.provisionsFacade.getAllProvisionsCase$().subscribe(provisions => {
        //   this.allProvisionsWithoutFilter = provisions;
        // })
        this._isLoadingGettingOrders = this.casesFacade.isLoadingGettingOrders$().subscribe(loading => this.isLoadingGettingOrders = loading);
        this._isLoadingUpdatingOrder = this.casesFacade.isLoadingUpdatingOrder$().subscribe(loading => this.isLoadingUpdatingOrder = loading);
        this._isLoadingCreatingOrder = this.casesFacade.isLoadingCreatingOrder$().subscribe(loading => this.isLoadingCreatingOrder = loading);
        this._historyModeDate = this.casesFacade.getCaseDateFilters$().subscribe(rangeDate => {
            if (!!rangeDate) {
                this.historyFromDate = rangeDate.historyFromDate;
                this.historyToDate = rangeDate.historyToDate;
            }
        })
        this._mdo = this.casesFacade.getMetaDataOrders$().subscribe((mdo) => {
            this.metaDataOrders = mdo;
        })

        this._provisionsDisplayedOnScreen = this.provisionsFacade.getProvisionsDisplayedOnScreen$().subscribe(provs => {
            this.provisionFees = provs?.filter(prov => prov.isSupply).flatMap(prov => {
                prov.provisionFees.forEach(provFee => {
                    const agreementForProvFee = prov.agreements?.find(ag => ag.provisionFeeId === provFee.id);
                    if (agreementForProvFee != null) {
                        provFee.agreement = agreementForProvFee;
                    }
                });
                return prov.provisionFees;
            });
            this.setOrderComposeWithProvisionFee();
        })

        this._filtersOnProvisions = this.provisionsFacade.getFiltersOnProvisions$().subscribe(filters => {

            if (!!filters) {
                this.provisionAgreementsInput = filters;

                if (!!this.provisionAgreementsInput.orders && this.provisionAgreementsInput.orders.length == 0) {
                    this.selection.clear();
                } else {
                    this.provisionAgreementsInput.orders?.forEach(sel => {
                        this.selectOrder(sel, true);
                    })
                }
            }
        })
        this._attentions = this.attentionsFacade.getAttentions$().subscribe(att => {
            this.attentions = att;
        })
    }

    setOrderComposeWithProvisionFee() {
        this.orders?.forEach(or => or?.items?.forEach(it => {
            let provFeeForItem = this.provisionFees.find(provFee => provFee.id == it.provisionFeeId);
            if (provFeeForItem != null) {
                it.provisionFee = provFeeForItem;
            }
        }))
    }

    setDataSourceAttributes() {
        if (this.paginator != null && this.paginator != undefined) {
            this.paginator.pageIndex = this.metaDataOrders.page;
            this.paginator.pageSize = this.metaDataOrders.size;
            this.paginator.length = this.metaDataOrders.rows;
            this.paginator._intl.itemsPerPageLabel = this.experienceI18n.translate('modules.cases.order-list.paginator.items-per-page', undefined, 'Registros por página');
            this.paginator._intl.firstPageLabel = this.experienceI18n.translate('modules.cases.order-list.paginator.first-page', undefined, 'Primera página');
            this.paginator._intl.lastPageLabel = this.experienceI18n.translate('modules.cases.order-list.paginator.last-page', undefined, 'Última página');
            this.paginator._intl.nextPageLabel = this.experienceI18n.translate('modules.cases.order-list.paginator.next-page', undefined, 'Página siguiente');
            this.paginator._intl.previousPageLabel = this.experienceI18n.translate('modules.cases.order-list.paginator.previous-page', undefined, 'Página anterior');
        }
    }

    onPaginatorEvent() {
        let ordersQPS: OrdersQPS = this.metaDataOrders;
        ordersQPS.size = this.paginator.pageSize;
        ordersQPS.page = this.paginator.pageIndex;
        ordersQPS.fromDate = this.historyFromDate;
        ordersQPS.toDate = this.historyToDate;
        this.casesFacade.loadOrders(ordersQPS, this.case.id);
    }

    validateIsAbleToModifyOrder(order: Order) {
        this.arrayTable = this.orderSharedActionsService.getBlockedOrderItems(order, this.attentions);
        return this.arrayTable.length == 0
    }

    openModifyOrderDialog(order?: Order, edition?: boolean) {
        this.isBillable = false;
        this.providersOnSelect = null;
        this.actualOrder = order;
        this.deliveringOrder = (order.state.id == this.ORDERS_STATES.EN_CURSO || order.state.id == this.ORDERS_STATES.ENTREGADO);
        this.editingOrder = edition;
        this.formModifyOrder = this.createModifyOrderForm(order);
        this.deliveryNote = false;

        if (!!this.actualOrder?.provider) {
            this.providersOnSelect = [this.actualOrder.provider];
            this.actualOrderProvider = this.actualOrder.provider.id.toString();
        }

        let text: string;

        this.deliveringOrder && this.editingOrder && (this.actualOrder.state.id != this.ORDERS_STATES.ENTREGADO)
            ? text = this.experienceI18n.translate('modules.cases.order-list.modify-dialog.title.load-delivery', undefined, 'Cargar entrega')
            : this.deliveringOrder && this.editingOrder && (this.actualOrder.state.id === this.ORDERS_STATES.ENTREGADO)
                ? text = this.experienceI18n.translate('modules.cases.order-list.modify-dialog.title.edit-delivery', undefined, 'Editar entrega')
                : text = this.experienceI18n.translate('modules.cases.order-list.modify-dialog.title.modify-order', undefined, 'Modificar Pedido');

        if (!this.editingOrder) {
            text = this.experienceI18n.translate('modules.cases.order-list.modify-dialog.title.view-order', undefined, 'Ver pedido')
        }

        // text += ` - ${this.entitiesFacade.getProvidersFullName(order?.provider)}`;
        this.dataSourceSupplies.data = this.itemsFormArray['controls'];
        if ((this.editingOrder && this.validateIsAbleToModifyOrder(order)) || !this.editingOrder) {
            setTimeout(() => {
                this.openDialog(text, this.modifyOrderTemplate, { maxHeight: '95vh', minWidth: this.deliveringOrder ? '70%' : '45%' }, () => {
                    this.deliveringOrder = false;
                    this.actualOrderProvider = null;
                });
            }, 200);
        } else {
            this.message = this.experienceI18n.translate('modules.cases.order-list.popup.supplies-already-informed', undefined, 'Los siguientes insumos ya están informados. No se puede modificar el estado del pedido.')
            this.openDialog(this.experienceI18n.translate('modules.cases.order-list.popup.attention', undefined, 'Atención'), this.popUpMessage, { minWidth: '30%', maxHeight: '70vh' }, () => { })
        }
    }

    createModifyOrderForm(order: Order) {

        let form: FormGroup = this.formBuilder.group({
            [this.ORDER_PROVIDER]: [order.provider.id.toString(), [CustomValidators.required(this.experienceI18n.translate('modules.cases.order-list.validators.provider-required', undefined, 'Proveedor requerido'))]],
            [this.ORDER_PROVIDER_SEARCHING]: [''],
            [this.ORDER_DATE]: [!!order.orderDate ? order.orderDate : '', [CustomValidators.required(this.experienceI18n.translate('modules.cases.order-list.validators.delivery-date-required', undefined, 'Fecha de entrega requerida'))]],
            [this.ORDER_DATE_DELIVERY]: [!!order.deliveryDate ? order.deliveryDate : (!!order.orderDate ? order.orderDate : '')],
            [this.ORDER_OBSERVATIONS]: [!!order.observations ? order.observations : ''],
            [this.ORDER_CONFIRMED]: [order.state.id == this.ORDERS_STATES.EN_CURSO],
            [this.ORDER_ITEMS]: this.formBuilder.array(this.createItemsFormArray(order.items)),
            [this.IS_BILLABLE]: [''],
        })
        if (this.deliveringOrder) {
            form.get(this.ORDER_PROVIDER).disable();
            form.get(this.ORDER_DATE).disable();
            form.get(this.ORDER_CONFIRMED).disable();
            form.get(this.ORDER_DATE_DELIVERY).setValidators(CustomValidators.required(this.experienceI18n.translate('modules.cases.order-list.validators.delivery-date-required', undefined, 'Fecha de entrega requerida')));
        }
        if (!this.editingOrder) {
            // If menu option selected is "Ver detalle", it disables all fields
            form.get(this.ORDER_OBSERVATIONS).disable();
            form.get(this.ORDER_DATE_DELIVERY).disable();
            form.get(this.ORDER_ITEMS).disable();
        }
        return form;
    }

    openDialog(title: string, template, style: { minWidth: string, maxHeight: string }, afterClosed?): void {
        this._dialogRef = this.dialog.open(DialogComponent, {
            disableClose: true,
            minWidth: style.minWidth,
            maxHeight: style.maxHeight,
            data: { template, title },
        })
        this._dialogRef.afterClosed().subscribe(() => afterClosed());
    }

    onClickCloseDialog() {
        if (this.savingOrderDialog) return;
        this._dialogRef.close();
        this.dialog.closeAll();
        this.deliveringOrder = false;
        this.actualOrderProvider = null;
    }

    createItemsFormArray(items: Item[]) {
        let itemsFormArray;
        itemsFormArray = items.map((item) => {
            if (!!item && !!item.id && !!item.practice?.id && !!item.practice.name) {
                let itemForm;
                itemForm = this.createItemForm(item);
                return itemForm;
            }
        })
        return itemsFormArray;
    }

    createItemForm(item: Item): FormGroup {
        let form = this.formBuilder.group({
            [this.ITEM_ID]: [item.id],
            [this.ITEM_QUANTITY]: [item.quantityOrdered, CustomValidators.required(this.experienceI18n.translate('modules.cases.order-list.validators.quantity-required', undefined, 'Cantidad requerida'))],
            [this.ITEM_PRICE]: [item.priceOrdered, CustomValidators.required(this.experienceI18n.translate('modules.cases.order-list.validators.price-required', undefined, 'Precio requerido'))],
            [this.ITEM_QUANTITY_DELIVERY]: [!!item.quantityDelivered ? item.quantityDelivered : (item.quantityOrdered ? item.quantityOrdered : '')],
            [this.ITEM_PRICE_DELIVERY]: [item.priceDelivered != null ? item.priceDelivered : (item.priceOrdered != null ? item.priceOrdered : '')],
            [this.ITEM_UNIT]: [item.unit],
            [this.ITEM_PRACTICE_DELIVERY]: [item.practice.id.toString()],
            [this.ITEM_PRACTICE_SEARCHING]: [''],
            [this.ITEM_PRACTICE]: [item.practice],

            // [this.ITEM_MARGIN]: [ {value: item.provisionFee.profitMargin, disabled: item.provisionFee.fixedPrice || this.editingOrder } ],
            [this.ITEM_MARGIN]: [{ value: item.provisionFee.profitMargin, disabled: (item.provisionFee.fixedPrice ? item.provisionFee.fixedPrice : false) || this.actualOrder?.agreement?.providerFee == 0 }],
            [this.ITEM_FEE]: [{ value: item.provisionFee.fee, disabled: item.provisionFee.fixedPrice }],
            [this.ITEM_KAIROS]: [{ value: !!item ? item.provisionFee.fixedPrice : false, disabled: false }],

            [this.ITEM_VISIBLE_CHECK_KAIROS]: [{ value: !!item ? item.provisionFee.fixedPrice : false, disabled: false }],

        })
        if (this.deliveringOrder) {
            form.get(this.ITEM_PRACTICE).disable();
            form.get(this.ITEM_QUANTITY).disable();
            form.get(this.ITEM_PRICE).disable();
            form.get(this.ITEM_PRICE_DELIVERY).setValidators([CustomValidators.minValue(0, this.experienceI18n.translate('modules.cases.order-list.validators.delivery-price-required', undefined, 'Precio de entrega requerido'))]);
            form.get(this.ITEM_QUANTITY_DELIVERY).setValidators([CustomValidators.minValue(0, this.experienceI18n.translate('modules.cases.order-list.validators.delivery-quantity-required', undefined, 'Cantidad entregada requerida'))]);
            form.get(this.ITEM_FEE).setValidators([CustomValidators.minValue(0, this.experienceI18n.translate('modules.cases.order-list.validators.required', undefined, 'Requerido'))]);
        }
        if (this.actualOrder.state.id == this.ORDERS_STATES.ENTREGADO) {
            form.get(this.ITEM_PRACTICE_DELIVERY).disable();
        }
        if (!this.editingOrder) {
            form.get(this.ITEM_PRICE_DELIVERY).disable();
            form.get(this.ITEM_QUANTITY_DELIVERY).disable();
            form.get(this.ITEM_PRACTICE_DELIVERY).disable();
        } else {
            if (this.actualOrder.state.id === this.ORDERS_STATES.ENTREGADO) {
                form.get(this.ITEM_MARGIN).disable();
                form.get(this.ITEM_FEE).disable();
                form.get(this.ITEM_KAIROS).disable();
            }
        }
        return form;
    }

    loadProvidersByFullName = (value: string) => this.entitiesFacade.loadProviders({ fullName_like: value, active: true, isSupply: true })

    calculateIdProvider(element: Provider) {
        return element ? element.id : null;
    }

    calculateNameProvider(element: Provider) {
        return element ? this.entitiesFacade.getProvidersFullName(element) : null;
    }

    onClickConfirmDelivery() {
        if (this.savingOrderDialog) return;
        if (this.deliveringOrder && this.isBillable) {
            // console.log(this.formModifyOrder.value)
            // || i.fee == 0
            let itemsWithCostOrFee0 = this.formModifyOrder.value.items.filter(i => i.priceDelivered == 0);
            if (itemsWithCostOrFee0.length > 0) {
                this.message = this.experienceI18n.translate('modules.cases.order-list.popup.supplies-with-zero-cost', undefined, 'Los siguientes insumos tienen costo o valor venta 0, ¿Desea continuar?')
                this.showConfirmBtn = true;
                this.txtCancelBtn = this.experienceI18n.translate('common.cancel', undefined, 'Cancelar');
                this.txtConfirmBtn = this.experienceI18n.translate('common.continue', undefined, 'Continuar');
                this.closeAll = false
                this.arrayTable = itemsWithCostOrFee0.map(i => {
                    let practiceForItem = this.actualOrder.items.find(it => it.id == i.id).practice?.name
                    return {
                        supplyName: practiceForItem,
                        quantity: i.quantityDelivered,
                        provider: `${this.actualOrder?.provider?.name} ${this.actualOrder?.provider?.surname}`
                    }
                })
                this.openDialog('Atención', this.popUpMessage, { minWidth: '30%', maxHeight: '70vh' }, () => { })
            } else {
                this.onClickUpdateOrder();
            }
        } else {
            this.onClickUpdateOrder();
        }
        // this.orders.forEach(order=>{
        //     if(order.state.id == OrdersStates.ENTREGADO){
        //         order.paintedType = null
        //     }
        // })
        this.dataSource.data = this.orders
    }

    onClickUpdateOrder() {
        if (this.savingOrderDialog) return;
        //TODO: próxima revisión eliminar si no hay errores
        // for (const key in this.formModifyOrder.controls) {
        //     if (Object.prototype.hasOwnProperty.call(this.formModifyOrder.controls, key)) {
        //         const control = this.formModifyOrder.controls[key];
        //         if (!control.touched && key != this.ORDER_DATE_DELIVERY) {
        //             delete this.formModifyOrder.value[key];
        //         }
        //     }
        // }
        if (this.deliveringOrder) {
            if (!this.fileChanged) {
                delete this.formModifyOrder.value.invoicePhoto
            } else {
                if (!!this.photoInvoice) {
                    this.formModifyOrder.value.invoicePhoto = this.photoInvoice;
                } else {
                    delete this.formModifyOrder.value.invoicePhoto;
                }
            }
            this.formModifyOrder.value.state = { id: this.ORDERS_STATES.ENTREGADO };
            this.formModifyOrder.value.items.map(item => {
                delete item.unit;
                delete item.practiceItemSearching;
                delete item.practiceItemDelivered;
                delete item.visibleCheckKairos;

                // Sets profit margin from rawValue because the field is disabled
                let rawValueItem = this.formModifyOrder?.getRawValue()?.items?.find(it => it.id == item.id);
                if (rawValueItem != null && rawValueItem.profitMargin != null) {
                    item.profitMargin = rawValueItem.profitMargin;
                }
                return item;
            });
            this.isBillable ? this.isBillable : delete this.formModifyOrder.value.isBillable; // If true -> create attentions with state FACTURABLE
        } else {
            if (!!this.formModifyOrder.value?.items) {
                this.formModifyOrder.value.items.map(item => {
                    item.practiceId = item.practice.id;
                    delete item.practice;
                    delete item.practiceItemDelivered;
                    delete item.practiceItemSearching;
                    delete item.priceDelivered;
                    delete item.quantityDelivered;
                    delete item.profitMargin;
                    delete item.fee;
                    delete item.fixedPrice;
                    delete item.visibleCheckKairos;
                    return item
                });
            }
            this.formModifyOrder.value.providerId = parseInt(this.formModifyOrder.value.providerId);
            this.formModifyOrder.value.state ? this.formModifyOrder.value.state = { id: this.ORDERS_STATES.EN_CURSO } : delete this.formModifyOrder.value.state;
        }
        delete this.formModifyOrder.value.deliveryNote
        let formValue: PatchOrderBody = this.formModifyOrder.value
        for (const property in formValue) {
            if (!(!!formValue[property]) && property != this.ORDER_OBSERVATIONS) {
                delete formValue[property]
            }
        }

        if (this.editingOrder) {
            if (this.actualOrder.state.id == this.ORDERS_STATES.ENTREGADO) {
                delete formValue.state
                formValue = { ...formValue, edition: true }
            }
        }

        if (this.deliveringOrder) {
            this.openSavingOrderDialog();
        }
        this.casesFacade.updateOrder(formValue, this.actualOrder.id, this.case.id).subscribe((order) => {
            this.swalWithCustomizeButtons.fire({
                text: this.experienceI18n.translate('modules.cases.order-list.update-order.success', undefined, 'El pedido se modificó correctamente'),
                icon: 'success',
                didOpen: () => this.closeSavingOrderDialog(),
            }).then(() => {
                this._dialogRef.close();
                this.dialog.closeAll();
                this.actualOrderProvider = null;

                // Load all provisions for case
                this.provisionsFacade.loadAllProvisionsForCase(this.case.id) // TODO: if possible only load provisionFees
            })
                .catch((e) => {
                    this._dialogRef.close();
                    this.actualOrderProvider = null;
                });
        }, (err) => {
            this.closeSavingOrderDialog();
            this.actualOrderProvider = null;
            this._dialogRef.close();
        });
    }

    private openSavingOrderDialog(): void {
        this.savingOrderDialog = this.dialog.open(this.savingOrderTemplate, {
            width: '100px',
            height: '100px',
            panelClass: 'open-saving-order-spinner',
            disableClose: true,
            autoFocus: 'dialog',
            delayFocusTrap: false,
            restoreFocus: false,
            enterAnimationDuration: 0,
            exitAnimationDuration: 0,
        });
    }

    private closeSavingOrderDialog(): void {
        this.savingOrderDialog?.close();
        this.savingOrderDialog = null;
    }

    onClickDeleteOrder(order: Order) {
        let orderToDelete: PatchOrderBody = {
            state: { id: 3 }
        };
        let text: string;
        let text2: string;
        this.swalWithCustomizeButtons.fire({
            title: this.experienceI18n.translate('modules.cases.order-list.popup.attention', undefined, 'Atención'),
            text: this.experienceI18n.translate('modules.cases.order-list.delete-order.confirmation', undefined, '¿Está seguro que desea cancelar el pedido?'),
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: this.experienceI18n.translate('common.confirm', undefined, 'Confirmar'),
            cancelButtonText: this.experienceI18n.translate('common.cancel', undefined, 'Cancelar'),
            showLoaderOnConfirm: true,
            reverseButtons: true,
            preConfirm: () => {
                return this.casesFacade.updateOrder(orderToDelete, order.id, this.case.id).toPromise()
                    .then((_) => {
                        this.swalWithCustomizeButtons.fire({
                            text: this.experienceI18n.translate('modules.cases.order-list.delete-order.success', undefined, 'Pedido cancelado correctamente'),
                            icon: 'success',
                        });
                    })
                    .catch((err) => {
                        console.log('error', err);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        })
    }

    pondOptions = {
        class: 'my-filepond',
        multiple: false,
        labelIdle: this.experienceI18n.translate('modules.cases.order-list.filepond.label-idle', undefined, 'Arrastre el archivo o haga click <u>aquí</u>'),
        labelFileTypeNotAllowed: this.experienceI18n.translate('modules.cases.order-list.filepond.invalid-file-type', undefined, 'Tipo de archivo inválido'),
        fileValidateTypeLabelExpectedTypes: this.experienceI18n.translate('modules.cases.order-list.filepond.accepted-formats', undefined, 'Formatos aceptados: jpg, jpeg, png, pdf'),
        acceptedFileTypes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
        imagePreviewMaxHeight: 150,
        files: [this.photoInvoice],
        maxFileSize: '10MB'
    };

    pondHandleInit() {
        this.photoInvoice = null;
        this.fileChanged = false;
        this.casesService.getInvoicePhotoByOrderId(this.actualOrder.id, this.case.id).subscribe({
            next: media => {
                if (!!media && !!media.mediaUrl) {
                    this.photoInvoice = media.mediaUrl;
                    this.myPond.addFile(this.photoInvoice);
                } else {
                    this.photoInvoice = null;
                }
            },
            error: er => {
                console.log('Error al cargar foto o no se econtro');
                this.photoInvoice = null;
            }
        })
    }

    pondHandleAddFile(event: any) {
        if (!event.error) {
            //Si es null quiere decir que no hay ninguna precargada, si no lo es quiere decir que ya hay foto
            if (this.photoInvoice == null) {
                const b64 = event.file.getFileEncodeBase64String();
                const extension = event.file.fileExtension;
                const mimeType = mime.getType(extension);;
                this.photoInvoice = `data:${mimeType};base64,${b64}`;
                this.fileChanged = true;
            }
        }
        else {
            this.photoInvoice = null;
        }
        this.loadingAddFile = false;
    }

    pondHandleRemoveFile(event) {
        this.photoInvoice = null;
        this.fileChanged = true;
    }

    pondHandleProcessFile(event) {
        this.loadingAddFile = true;
    }

    show(ev) {
        console.log(ev);
    }

    isAllSelected() {
        const numSelected = this.selection.selected.filter(selected => this.dataSource.data.some(prov => prov.id == selected.id)).length;
        const totalProvisions = this.dataSource.data.length;
        return numSelected === totalProvisions;
    }

    masterToggle() {

        if (this.isAllSelected()) {
            this.selection.clear();
        } else {
            if (!!this.dataSource.data && this.dataSource.data.length > 0) {
                this.dataSource.data.forEach(row => this.selectOrder(row, true));
            }
        }
        this.provisionsFacade.setFiltersOnProvisions(this.updateFilter());
    }

    selectOrder(row: Order, masterToggle: boolean = false) {
        if (!masterToggle || (masterToggle && !this.selection.selected.map(sel => sel.id).includes(row.id))) {
            if (this.selection.selected.map(sel => sel.id).includes(row.id)) {
                this.selection.deselect(this.selection.selected.find(sel => sel.id == row.id));
            } else {
                if (!this.selection.selected.map(sel => sel.id).includes(row.id)) {
                    this.selection.select(row);
                }
            }
        }
        if (!masterToggle) {
            this.provisionsFacade.setFiltersOnProvisions(this.updateFilter());
        }
    }

    getItemsCount(order: Order) {
        let count: number = order.items.length;
        if (count == 1) {
            return this.experienceI18n.translate('modules.cases.order-list.count.supply-singular', { count }, '{count} insumo');
        } else {
            return this.experienceI18n.translate('modules.cases.order-list.count.supply-plural', { count }, '{count} insumos');
        }
    }

    updateFilter() {
        // Cuando no hay orders seleccionados, limpiar todos los filtros para mostrar todos
        if (this.selection.selected.length === 0) {
            return {
                provisions: [],
                provisionFees: [],
                agreements: [],
                provisionsSupplies: [],
                provisionAgreementsSupplies: [],
                orders: [],
            } as ProvisionAgreementFilters;
        }
        if (!!this.provisionAgreementsInput) {
            delete this.provisionAgreementsInput.orders;
        }
        return { ...this.provisionAgreementsInput, orders: [...this.selection.selected] }
    }

    dateDiff(day: Date): number {
        if (!!day) return moment(day).diff(this.toDay, 'days');
        else return -1; // Vencido / hay un error en la fecha
    }


    getColorAuthorizationState(provisionFee: ProvisionFee) {
        if (!!provisionFee) {
            let state = this.generalService.getAuthorizationStatus(provisionFee.authorization);
            return this.AUTHORIZATION_COLORS[state];
        }
        return '';
    }

    getBackgroundColorAuthorizationState(provisionFee: ProvisionFee): string {
        if (!!provisionFee) {
            let state = this.generalService.getAuthorizationStatus(provisionFee.authorization);
            return this.AUTHORIZATION_BACKGROUND_COLORS[state];
        }
        return '';
    }

    onClickAuthorization(provisionFee: ProvisionFee) {
        if (this.generalService.getAuthorizationStatus(provisionFee?.authorization) !== AuthorizationState.UNAUTHORIZED) {
            this.showAuthEvolution(provisionFee?.authorization);
        }
    }
    showAuthEvolution(auth) {
        // Find evolution
        this.evolutionsFacade.loadEvolutionsById(auth.evolutionId).subscribe(evol => {
            this._bottomSheet.open(EvolutionsDialogComponent, {
                panelClass: 'bottomSheetPanelClass',
                data: {
                    evolutions: [evol],
                    attentions: [],
                    name: this.case.patient.name,
                    surname: this.case.patient.surname,
                    expanded: true
                },
            });
        })
    }

    onChangeCheckIsBillable(isChecked: boolean) {
        this.isBillable = isChecked;
    }
    onClickCancel() {
        if (this.savingOrderDialog) return;
        this._dialogRef.close();
        if (this.closeAll) {
            this.dialog.closeAll();
        }
    }

    revertState(order: Order) {
        if (this.savingOrderDialog) return;

        this.openMessageDialogComponent(this.experienceI18n.translate('modules.cases.order-list.revert-state.confirmation', { orderId: order.id }, '¿Está seguro que desea revertir el estado del pedido {orderId}?'));
        const confirmationDialogRef = this._dialogRef;

        confirmationDialogRef.componentInstance.ok.subscribe(result => {
            if (result) {

                const notInformedItems = this.orderSharedActionsService.getBlockedOrderItems(
                    order,
                    (this.attentions ?? []).filter(
                        attention => attention?.state?.id === AttentionStates.NO_INFORMADA
                    )
                );
                // Creates popUp with text area
                if (this.validateIsAbleToModifyOrder(order)) {
                    if (order.provider && order.provider.active === false) {
                        this.swalWithCustomizeButtons.fire({
                            icon: 'warning',
                            text: this.experienceI18n.translate('modules.cases.order-list.messages.prestador-inhabilitado', undefined,
                                'No se puede acceder al prestador con el que se quiere operar. Contacte a un superior.'),
                        });
                        this._dialogRef.close();
                        return;
                    }
                    this.swalWithCustomizeButtons.fire({
                        icon: 'warning',
                        title: this.experienceI18n.translate('modules.cases.order-list.revert-state.anormal-flow-warning', undefined, 'Advertencia de flujo anormal'),
                        text: this.experienceI18n.translate('modules.cases.order-list.revert-state.write-reason-text', undefined, 'Por favor, escriba un motivo'),
                        input: 'textarea',
                        inputPlaceholder: this.experienceI18n.translate('modules.cases.order-list.revert-state.write-reason-placeholder', undefined, 'Escriba un motivo... '),
                        inputValidator: (value) => {
                            if (value.length < 10) {
                                return this.experienceI18n.translate('modules.cases.order-list.revert-state.reason-min-length', undefined, 'El motivo debe tener más de 10 caracteres.');
                            } else {
                                return ''
                            }
                        },
                        confirmButtonText: this.experienceI18n.translate('common.confirm', undefined, 'Confirmar'),
                        cancelButtonText: this.experienceI18n.translate('common.cancel', undefined, 'Cancelar'),
                        showLoaderOnConfirm: true,
                        showCancelButton: true,
                        reverseButtons: true,
                        allowOutsideClick: () => !Swal.isLoading(),
                    }).then(result => {
                        if (result.isConfirmed) {
                            this.openSavingOrderDialog();
                            // If the confirm button is pressed, creates the patch body and calls the endpoint
                            let patchOrderBody: PatchOrderBody = {
                                stateReversed: true,
                                reasonForRevertingOrderStatus: result.value
                            }

                            this.casesFacade.updateOrder(patchOrderBody, order.id, this.case.id).subscribe({
                                next: order => {
                                    this.swalWithCustomizeButtons.fire({
                                        text: this.experienceI18n.translate('modules.cases.order-list.update-order.success', undefined, 'El pedido se modificó correctamente'),
                                        icon: 'success',
                                        didOpen: () => this.closeSavingOrderDialog(),
                                    }).then(() => {
                                        this._dialogRef.close();
                                    })
                                        .catch((e) => {
                                            this._dialogRef.close();
                                        });
                                },
                                error: (err: HttpErrorResponse) => {
                                    this.closeSavingOrderDialog();
                                    this._dialogRef.close();

                                    if (err.status === 418) {
                                        const errorContent: HttpBaseResponseErrorTeaPot = err.error;

                                        this.swalWithCustomizeButtons.fire({
                                            title: errorContent.message,
                                            text: errorContent.data.message,
                                            icon: 'error',
                                        });
                                    }
                                }
                            })
                        } else {
                            this._dialogRef.close();
                        }
                    });
                } else if (notInformedItems.length > 0){
                    this.arrayTable = notInformedItems;
                    this.message = this.experienceI18n.translate('modules.cases.order-list.popup.supplies-not-informed', undefined, 'No se puede modificar el estado del pedido porque hay insumos en estado NO INFORMADO, pasalos a estado FACTURABLE para poder revertir la entrega.');
                    this.showConfirmBtn = false;
                    this.closeAll = false;
                    this.txtCancelBtn = this.experienceI18n.translate('common.ok', undefined, 'Ok');
                    this.openDialog(this.experienceI18n.translate('modules.cases.order-list.popup.attention', undefined, 'Atención'), this.popUpMessage, { minWidth: '30%', maxHeight: '70vh' }, () => confirmationDialogRef.close());
                    return;
                } else {
                    this.message = this.experienceI18n.translate('modules.cases.order-list.popup.supplies-already-informed', undefined, 'Los siguientes insumos ya están informados. No se puede modificar el estado del pedido.')
                    this.showConfirmBtn = false;
                    this.closeAll = false;
                    this.txtCancelBtn = this.experienceI18n.translate('common.ok', undefined, 'Ok')
                    this.openDialog(this.experienceI18n.translate('modules.cases.order-list.popup.attention', undefined, 'Atención'), this.popUpMessage, { minWidth: '30%', maxHeight: '70vh' }, () => confirmationDialogRef.close());
                    return;
                }

            }
        })
    }

    openMessageDialogComponent(message) {
        this._dialogRef = this.dialog.open(MessageDialogComponent, {
            disableClose: false,
            maxHeight: '20%',
            maxWidth: '50vh',
            data: {
                message: message,
                icon: 'WarningCircle',
                disableConfirm: true,
            }
        });
    }

    showDeliveryNote(order: Order) {
        this.orderSharedActionsService.getDeliveryNoteContext(order, this.attentions)
            .then(({ attention, deliveryNote }) => {
                if (!!attention && !!deliveryNote) {
                    attention.evolutions = [deliveryNote];
                    this._bottomSheet.open(EvolutionsDialogComponent, {
                        panelClass: 'bottomSheetPanelClass',
                        data: {
                            evolutions: [deliveryNote],
                            name: attention.patient.name,
                            surname: attention.patient.surname,
                            attentions: [attention]
                        },
                    });
                }
            })
    }

    onChangeCheckdeliveryNote(isChecked: boolean) {
        this.deliveryNote = isChecked;
        console.log(this.deliveryNote)
    }

    /**
     *
     * @returns If true then exists some item with fixedPrice (Kairos)
     */
    existsCheckItemsWithKairos(): boolean {
        let control: boolean = false;
        this.itemsFormArray.controls.forEach((element, index) => {
            if (element.get('visibleCheckKairos').value && element.get('fixedPrice').value)
                control = true;
        })
        return control;
    }

    onChangeCheckKairos(i: number, isSelected: boolean) {
        if (isSelected) {
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).reset();
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).disable();
            this.itemsFormArray.at(i).get(this.ITEM_FEE).reset();
            this.itemsFormArray.at(i).get(this.ITEM_FEE).disable();
        } else {
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).enable();
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).setValidators(CustomValidators.required(this.experienceI18n.translate('modules.cases.order-list.validators.required', undefined, 'Requerido')));
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).updateValueAndValidity();
            this.itemsFormArray.at(i).get(this.ITEM_FEE).enable();
            this.itemsFormArray.at(i).get(this.ITEM_FEE).setValidators(CustomValidators.required(this.experienceI18n.translate('modules.cases.order-list.validators.required', undefined, 'Requerido')));
            this.itemsFormArray.at(i).get(this.ITEM_FEE).updateValueAndValidity();
        }
    }

    calculateTotalValue(i: number) {
        let margin = this.itemsFormArray.at(i).get(this.ITEM_MARGIN).value;
        let cost = this.itemsFormArray.at(i).get(this.ITEM_PRICE_DELIVERY).value;
        if (cost != null && cost != 0) {
            this.itemsFormArray.at(i).get(this.ITEM_FEE).setValue(cost + (cost * margin / 100));
            this.itemsFormArray.at(i).get(this.ITEM_FEE).markAsPristine();
        } else {
            this.itemsFormArray.at(i).get(this.ITEM_FEE).reset();
            this.itemsFormArray.at(i).get(this.ITEM_FEE).disable();
        }
    }
    calculateMargin(i: number) {
        let cost = this.itemsFormArray.at(i).get(this.ITEM_PRICE_DELIVERY).value;
        let fee = this.itemsFormArray.at(i).get(this.ITEM_FEE).value;
        if (cost != 0 && cost != null) {
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).setValue((((fee - cost) / cost) * 100).toFixed(2));
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).markAsPristine();
        } else {
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).reset();
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).disable();
        }
    }

    onChangeCost(i) {
        let fee = this.itemsFormArray.at(i).get(this.ITEM_FEE).value;
        let margin = this.itemsFormArray.at(i).get(this.ITEM_MARGIN).value;
        let cost = this.itemsFormArray.at(i).get(this.ITEM_PRICE_DELIVERY).value;
        if (cost == 0) {
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).reset();
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).disable();
        } else {
            this.itemsFormArray.at(i).get(this.ITEM_MARGIN).enable();
        }
        if ((margin != 0 && margin != null && (fee == 0 || fee == null)) || this.itemsFormArray.at(i).get(this.ITEM_MARGIN).dirty) {
            // If cost is changed and there isn't fee or profit margin is the last touched field, it calculates fee
            this.calculateTotalValue(i)
        } else if ((fee != 0 && fee != null && (margin == 0 || margin == null)) || this.itemsFormArray.at(i).get(this.ITEM_FEE).dirty) {
            // If there isn't margin or fee is the last touched field, it calculates margin
            this.calculateMargin(i)
        } else if ((this.itemsFormArray.at(i).get(this.ITEM_FEE).pristine && this.itemsFormArray.at(i).get(this.ITEM_MARGIN).pristine) && (fee != 0 && fee != null)) {
            // If there is margin and fee and both of them are untouched, it calculates margin
            this.calculateMargin(i)
        }
    }

    public generateDeliveryNotePDF(order: Order) {
        this.orderSharedActionsService.downloadDeliveryNotePdf(order, this.case?.patient?.id)
    }

    getItemsFormArray(index: number): FormGroup {
        return this.itemsFormArray.at(index) as FormGroup;
    }

    onClickGenerateDeliveryNote(order) {
        this.generateDeliveryNotePDF(order)
    }
}
